import type { TOfferType } from "@components/AccountNew/OfferFunnel/utils/useAccountOfferFunnel"
import type { IAccount } from "./types"

export const RAF_TEMPLATES = ["refer_a_friend", "add_referral"]

export const unretainableStatusGroups = [
  "Dropped",
  "Rejected",
  "Ineligible",
  "Cancelled",
  "Duplicate",
]
export const unretainableStatusCodes = ["DROP_REQUEST", "DROP_ACCEPT"]
export const rejectedStatusCodes = ["Rejected"]

export const showDropInformation = (
  statusGroup: string | undefined,
  statusCode: string | undefined,
): boolean => {
  if (!statusGroup || !statusCode) return false
  return (
    unretainableStatusGroups.includes(statusGroup) ||
    unretainableStatusCodes.includes(statusCode)
  )
}

export const showRejectInformation = (
  statusGroup: string | undefined,
): boolean => {
  if (!statusGroup) return false
  return rejectedStatusCodes.includes(statusGroup)
}

export const hasWinbackOffers = (account: IAccount) => {
  return account.status_group === "Dropped" ||
    (account.status_group == "Active" &&
      account.status_description == "Active - Cancel Pending")
    ? true
    : false
}

export const hasRetentionOffers = (account: IAccount) => {
  return !unretainableStatusGroups.includes(account.status_group) &&
    !unretainableStatusCodes.includes(account.account_status_code)
    ? true
    : false
}

export const getTypeForOffersFunnel = (account: IAccount): TOfferType => {
  return hasRetentionOffers(account)
    ? "Retention"
    : hasWinbackOffers(account)
      ? "Winback"
      : "Winback"
}
